
import { Button } from 'element-ui';
import { ProductHelpers } from '@/helpers/ProductHelpers.js';

export default {
  props: {
    productId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      productHelpers: new ProductHelpers(this.$http, this, this.$i18n.locale),
      productsRelative: [],
    };
  },
  computed: {},
  methods: {
    async getProductRelative() {
      try {
        const id = this.productId;
        const productHelpers = new ProductHelpers(this.$http, this);
        const params = {
          idProduct: id,
          languageIsoCode: this.$i18n.locale,
          currencyIsoCode: this.$localisation.appCurrency.CurrencyIsoCode,
        };

        const data = await productHelpers.productsAssociation(params);
        this.productsRelative = data;
      } catch (error) {
        console.log('error', error);
      }
    },
  },
  async mounted() {
    this.getProductRelative();
  },
  components: {
    Button,
  },
};
